export default class StarsPopup extends Phaser.Group {
  constructor(game, stars, autoHide = true) {
    super(game);

    this.stars = stars;

    this.popup = this.game.make.image(0, 0, 'ui_various', 'star_popup');
    this.popup.anchor.set(0.5, 1);
    this.addChild(this.popup);

    this.popup.scale.set(0);
    this.game.add
      .tween(this.popup.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Quadratic.Out, true)
      .onComplete.add(this.showStars, this);

    if (autoHide) {
      this.game.time.events.add(1500, this.hide, this);
    }
  }

  showStars() {
    const positions = [{ x: -59, y: -65 }, { x: 1, y: -74 }, { x: 59, y: -65 }];
    for (let i = 0; i < this.stars; i++) {
      const x = positions[i].x;
      const y = positions[i].y;
      const star = this.game.make.image(x, y, 'ui_various', 'star_' + (i + 1));
      star.anchor.set(0.5);
      star.scale.set(0);
      this.addChild(star);

      this.game.add
        .tween(star.scale)
        .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true, 100 * i);
    }
  }

  hide() {
    this.game.add
      .tween(this.scale)
      .to({ x: 0, y: 0 }, 300, Phaser.Easing.Back.In, true)
      .onComplete.add(this.destroy, this);
  }

  destroy() {
    this.popup = null;
    super.destroy();
  }
}
